var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "lg": "9",
      "md": "10",
      "sm": "12"
    }
  }, [_c('b-card', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_vm.qrCode ? _c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "href": _vm.qrCode,
      "download": "QR Code ".concat(_vm.asset.nama || 'asset')
    }
  }, [_vm._v(" Download ")]) : _vm._e()]), _vm.qrCode ? _c('div', {
    staticClass: "w-100 d-flex flex-column",
    attrs: {
      "id": "qrcode-container"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-center mb-1"
  }, [_c('button', {
    staticClass: "asset-qr-thumb btn btn-link p-0 border-0",
    attrs: {
      "type": "button",
      "title": "Klik untuk memperbesar (scan)"
    },
    on: {
      "click": function click($event) {
        _vm.showQrModal = true;
      }
    }
  }, [_c('img', {
    staticClass: "d-block",
    attrs: {
      "src": _vm.qrCode,
      "alt": "QR Code"
    }
  })])]), _c('p', {
    staticClass: "text-center text-muted small mb-0"
  }, [_vm._v("Klik QR untuk memperbesar")])]) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-center mb-3 mt-1"
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.reloadQrCode($event);
      }
    }
  }, [_vm._v(" Muat Ulang QR Code ")]), _vm.qrCode ? _c('b-button', {
    attrs: {
      "variant": "info"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.printQrCode($event);
      }
    }
  }, [_vm._v(" Cetak ")]) : _vm._e()], 1), _c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', [_vm._v("Nama Aset")]), _c('th', [_vm._v(_vm._s(_vm.asset ? _vm.asset.nama : ''))])]), _c('tr', [_c('td', [_vm._v("Kode")]), _c('th', [_vm._v(_vm._s(_vm.asset ? _vm.asset.kode : ''))])]), _c('tr', [_c('td', [_vm._v("Jenis Aset")]), _c('th', [_vm.asset ? _c('div', [_vm._v(" " + _vm._s(_vm.asset.jenis == 1 ? 'TETAP' : 'BHP') + " ")]) : _vm._e()])]), _c('tr', [_c('td', [_vm._v("Kategori")]), _c('th', [_vm.asset ? _c('div', [_vm._v(" " + _vm._s(_vm.asset.kategori ? _vm.asset.kategori.kategori : '') + " ")]) : _vm._e()])]), _c('tr', [_c('td', [_vm._v("Jumlah")]), _c('th', [_vm._v(_vm._s(_vm.asset ? _vm.asset.jumlah : ''))])]), _c('tr', [_c('td', [_vm._v("Harga Dasar ")]), _c('th', [_vm._v("Rp " + _vm._s(_vm.asset ? _vm.formatRupiah(_vm.asset.harga_dasar) : 0))])]), _c('tr', [_c('td', [_vm._v("Keterangan")]), _c('th', [_vm._v(_vm._s(_vm.asset ? _vm.asset.keterangan : ''))])]), _c('tr', [_c('td', [_vm._v("Satuan")]), _c('th', [_vm.asset ? _c('div', [_vm._v(" " + _vm._s(_vm.asset.satuan ? _vm.asset.satuan.satuan : '') + " ")]) : _vm._e()])])])])], 1)], 1), _c('b-modal', {
    attrs: {
      "title": "QR Code Aset",
      "size": "md",
      "centered": "",
      "hide-footer": "",
      "body-class": "text-center"
    },
    model: {
      value: _vm.showQrModal,
      callback: function callback($$v) {
        _vm.showQrModal = $$v;
      },
      expression: "showQrModal"
    }
  }, [_vm.qrCode ? _c('img', {
    staticClass: "asset-qr-full d-block mx-auto",
    attrs: {
      "src": _vm.qrCode,
      "alt": "QR Code full size"
    }
  }) : _vm._e(), _c('p', {
    staticClass: "text-muted small mt-1 mb-0"
  }, [_vm._v("Arahkan kamera ke QR untuk scan")])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }